<template>
	<BaseCenteredMessage data-test="session-blocked-for-user">
		<template #title>You do not have access to this recording</template>
		<template #details>
			Please contact one of the members of this workspace to change your role and get access to this recording.
		</template>
	</BaseCenteredMessage>
</template>
